module.exports = __webpack_public_path__ + "img/brasil-flag.ec670a11.png";